export default __webpack_public_path__ + "static/media/service-img2.9ee05567.jpg";